import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PersonalDetailsSection = ({ member, isEditing, formData, onFormChange, errors }) => {
  const genderOptions = [
    { value: 'male', label: 'Masculino' },
    { value: 'female', label: 'Feminino' },
    { value: 'other', label: 'Outro' },
    { value: 'prefer-not-to-say', label: 'Prefiro não informar' }
  ];

  const maritalStatusOptions = [
    { value: 'single', label: 'Solteiro(a)' },
    { value: 'married', label: 'Casado(a)' },
    { value: 'divorced', label: 'Divorciado(a)' },
    { value: 'widowed', label: 'Viúvo(a)' },
    { value: 'separated', label: 'Separado(a)' }
  ];

  const occupationOptions = [
    { value: 'student', label: 'Estudante' },
    { value: 'employed', label: 'Empregado(a)' },
    { value: 'self-employed', label: 'Autônomo(a)' },
    { value: 'unemployed', label: 'Desempregado(a)' },
    { value: 'retired', label: 'Aposentado(a)' },
    { value: 'homemaker', label: 'Dona(o) de casa' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="User" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-foreground">Dados pessoais</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* First Name */}
        <div>
          {isEditing ? (
            <Input
              label="First Name"
              type="text"
              value={formData?.firstName}
              onChange={(e) => onFormChange('firstName', e?.target?.value)}
              error={errors?.firstName}
              required
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">First Name</label>
              <p className="text-foreground font-medium">{member?.firstName}</p>
            </div>
          )}
        </div>

        {/* Last Name */}
        <div>
          {isEditing ? (
            <Input
              label="Last Name"
              type="text"
              value={formData?.lastName}
              onChange={(e) => onFormChange('lastName', e?.target?.value)}
              error={errors?.lastName}
              required
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">Last Name</label>
              <p className="text-foreground font-medium">{member?.lastName}</p>
            </div>
          )}
        </div>

        {/* Date of Birth */}
        <div>
          {isEditing ? (
            <Input
              label="Date of Birth"
              type="date"
              value={formData?.dateOfBirth}
              onChange={(e) => onFormChange('dateOfBirth', e?.target?.value)}
              error={errors?.dateOfBirth}
              required
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">Date of Birth</label>
              <p className="text-foreground font-medium">
                {new Date(member.dateOfBirth)?.toLocaleDateString()}
              </p>
            </div>
          )}
        </div>

        {/* Gender */}
        <div>
          {isEditing ? (
            <Select
              label="Gender"
              options={genderOptions}
              value={formData?.gender}
              onChange={(value) => onFormChange('gender', value)}
              error={errors?.gender}
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">Gender</label>
              <p className="text-foreground font-medium capitalize">{member?.gender}</p>
            </div>
          )}
        </div>

        {/* Marital Status */}
        <div>
          {isEditing ? (
            <Select
              label="Marital Status"
              options={maritalStatusOptions}
              value={formData?.maritalStatus}
              onChange={(value) => onFormChange('maritalStatus', value)}
              error={errors?.maritalStatus}
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">Marital Status</label>
              <p className="text-foreground font-medium capitalize">{member?.maritalStatus}</p>
            </div>
          )}
        </div>

        {/* Occupation */}
        <div>
          {isEditing ? (
            <Select
              label="Occupation"
              options={occupationOptions}
              value={formData?.occupation}
              onChange={(value) => onFormChange('occupation', value)}
              error={errors?.occupation}
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">Occupation</label>
              <p className="text-foreground font-medium capitalize">{member?.occupation}</p>
            </div>
          )}
        </div>

        {/* CPF */}
        <div>
          {isEditing ? (
            <Input
              label="CPF"
              type="text"
              value={formData?.cpf}
              onChange={(e) => onFormChange('cpf', e?.target?.value)}
              error={errors?.cpf}
              placeholder="000.000.000-00"
              required
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">CPF</label>
              <p className="text-foreground font-medium">{member?.cpf}</p>
            </div>
          )}
        </div>

        {/* Voter ID */}
        <div>
          {isEditing ? (
            <Input
              label="Voter ID"
              type="text"
              value={formData?.voterId}
              onChange={(e) => onFormChange('voterId', e?.target?.value)}
              error={errors?.voterId}
              placeholder="0000 0000 0000"
            />
          ) : (
            <div>
              <label className="text-sm font-medium text-muted-foreground">Voter ID</label>
              <p className="text-foreground font-medium">{member?.voterId || 'Not provided'}</p>
            </div>
          )}
        </div>

        {/* Membership Type */}
        <div>
          <label className="text-sm font-medium text-muted-foreground">Membership Type</label>
          <p className="text-foreground font-medium capitalize">{member?.membershipType || 'Regular'}</p>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailsSection;